



























// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getDefaultAloPiscine, AloPiscine } from '@/models/alo/AloPiscine';
import {  groupByNumber, toNumberDictionary, toNumberLookup } from '@/utils/groupBy';
import { getImageUrl } from '@/utils/images';
import { AloTemplateCours, getDefaultAloTemplateCours } from '@/models/alo/AloTemplateCours';
import { AloTemplateHoraire, getDefaultAloTemplateHoraire } from '@/models/alo/AloTemplateHoraire';
import { getDefaultAloActivity } from '@/models/alo/AloActivity';

@Component({
  name: 'ReadTemplateCours',    
   props: {
    tc:{      
      type:Object,
      default:getDefaultAloTemplateCours()
    },
    piscine:{
      type:Object,
      default:getDefaultAloPiscine()
    }
  }
})
export default class ReadTemplateCours extends Vue {
  private tc!:AloTemplateCours
  private piscine!:AloPiscine
  private loading!:boolean
  private jours = [0,1,2,3,4,5,6]
  private selectedJours = [] as Array<number>
  private heures = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]
  private minutes = [0,5,10,15,20,25,30,35,40,45,50,55,60]
  
  mounted(){
    this.selectedJours = Object.keys(this.joursCours).map(k => parseInt(k)); 
  }

  @Watch('tc')
  onTmplateChanged(){
    this.selectedJours = Object.keys(this.joursCours).map(k => parseInt(k)); 
  }  


  get dicJour(){
    return toNumberDictionary(this.selectedJours, j=>j);
  }

  get imageUrl(){
    return getImageUrl(this.activite?.image)
  }

  get activite(){
    return this.activityDic[this.tc.acyId] 
  }

  get activityDic(){
    return this.$store.myGetters.activityDic
  }

  get activitySecondaire(){
    return [
      {...getDefaultAloActivity(),libelle:"Aucune"},
      ...this.$store.myGetters.activityList.filter(a => a.id != this.tc.acyId)
      ]
  }

  get configuration(){    
    return this.$store.myGetters.configuration
  }

  get joursCours() {
    return toNumberLookup(this.tc.horaires,t=>t.thrJour)
  }

  addHorraire(jour:number) {
    let heure = undefined;
    let minute = undefined;
    if(this.joursCours[jour]){
      const temps = Math.max(...this.joursCours[jour].map(h => h.thrHeure * 60 + h.thrMinute))
      heure = Math.floor(temps / 60) + 1
      minute = temps % 60
    } 
    this.tc.horaires.push(getDefaultAloTemplateHoraire(jour,heure,minute))
  }

  removeHoraire(horaire:AloTemplateHoraire) {
    const index = this.tc.horaires.findIndex(h => h.usrId == horaire.usrId && h.thrJour == horaire.thrJour && h.thrHeure == horaire.thrHeure && h.thrMinute == horaire.thrMinute)
    if(index > -1) this.tc.horaires.splice(index,1)
  }

  updateCours(all=false) {
    this.$nextTick(()=>{
      if(all && !this.tc.selected) {
        this.tc.horaires.splice(0,this.tc.horaires.length)
        this.selectedJours = []
      }
      this.tc.horaires = this.tc.horaires.filter(h => !!this.dicJour[h.thrJour])
    })
  }
}
